import { render, staticRenderFns } from "./Geofencing.vue?vue&type=template&id=2b8d9a08&"
import script from "./Geofencing.vue?vue&type=script&lang=js&"
export * from "./Geofencing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports